import {
  Alert,
  Box,
  CircularProgress,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { AccountPageLayout } from "components/common/AccountPageLayout";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import { Link as RouterLink, useLocation } from "react-router";
import { useListHeatOverrideRecipesQuery } from "src/store/api/generatedApi";
import { OverrideRecipeMix } from "./OverrideRecipeCard";
import { OVERRIDE_SAVED_STATE } from "./routes";
import { RetryErrorAlert } from "components/common/alerts/RetryErrorAlert";

export const OverridesPage = () => {
  const { t } = useTenantTranslation();
  const tenantName = useTenant();
  const location = useLocation();
  const recipes = useListHeatOverrideRecipesQuery(
    { tenantName },
    { refetchOnMountOrArgChange: true }
  );
  const saved = location.state === OVERRIDE_SAVED_STATE;

  return (
    <AccountPageLayout title={t("recipes")}>
      <Box sx={{ width: "100%", maxWidth: "sm" }}>
        <Stack sx={{ gap: 2 }}>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            {t("overridesPageHelp")}
          </Typography>
          {saved && (
            <Alert severity="success">{t("overrideRecipeSaved")}</Alert>
          )}
          {recipes.isFetching ? (
            <CircularProgress />
          ) : recipes.isError ? (
            <RetryErrorAlert
              message={t("overrideRecipesLoadError")}
              onRetry={() => {
                void recipes.refetch();
              }}
            />
          ) : (
            <Stack sx={{ gap: 1.5 }}>
              {recipes.data?.items.map((recipe) => (
                <Box
                  key={`${recipe.fixed_mix_set_id}:${recipe.mix_id}`}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 2,
                    border: 1,
                    borderColor: "grey.300",
                    borderRadius: 1,
                    p: 1.5,
                  }}
                >
                  <Stack sx={{ gap: 1 }}>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "fontWeightBold" }}
                    >
                      {recipe.name}
                    </Typography>
                    <OverrideRecipeMix mix={recipe.mix} />
                  </Stack>
                  <Link
                    component={RouterLink}
                    to={`${recipe.fixed_mix_set_id}/edit`}
                    variant="body2"
                  >
                    {t("edit")}
                  </Link>
                </Box>
              ))}
              {recipes.data?.items.length === 0 && (
                <Alert severity="info">{t("noOverrideRecipes")}</Alert>
              )}
            </Stack>
          )}
        </Stack>
      </Box>
    </AccountPageLayout>
  );
};
